/* eslint-disable max-len */

export default {
    name       : 'IntervenerStatusTimeline',

    /**
     * @override
     */
    data() {
        return {
            intervenerHistoric: [],
            intervenerStatusStep: 0,
            statusToChange: {},
            statusesOptions: [
                {
                    keyOptions: ['REGISTERED_ONLINE', 'REGISTERED_EMAIL', 'REGISTERED_POSTAL', 'REGISTERED'],
                    key: 'REGISTERED',
                    date: null,
                    complete: true,
                    user: null
                },
                {
                    key: 'SIGNED',
                    date: null,
                    complete: false,
                    user: null
                },
                {
                    key: 'VALIDADO',
                    date: null,
                    complete: false,
                    user: null
                },
                {
                    key: 'ENVIADO',
                    date: null,
                    complete: false,
                    user: null
                },
                {
                    key: 'FINALIZADO',
                    date: null,
                    complete: false,
                    user: null
                }
            ],
            statuses: []
        };
    },
    props: {
        intervener: {
            type: Object,
            required: true
        }
    },
    methods: {
        /**
         * Obtenemos la información relativa al historico del interviniente
         */
        fetchData() {
            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            this.$intervenersService.getIntervenerHistoric(this.intervener.uuid, cfg)
                .then(res => {
                    this.intervenerHistoric = res.data.intervener_historical;
                    this.intervenerHistoric.map(item => {
                        for (let index = 0; index < this.statuses.length; index++) {
                            const element = this.statuses[index];
                            if (element.key === item.status || (element.keyOptions && element.keyOptions.includes(item.status))) {
                                element.key = item.status;
                                element.date = item.created_on;
                                element.user = item.user_info;
                                element.complete = true;
                            }
                        }
                        return item;
                    });

                    if (this.intervener.personal_data.intervener_status === 'BLOQUEADO') {
                        const historicStates = new Set();
                        this.intervenerHistoric.forEach(state => {
                            historicStates.add(state.status);
                        });
                        this.intervenerStatusStep = Array.from(historicStates).length;
                    }
                });
        },
        // si el estado firmado no tiene fecha significa que se ha saltado a validado y por lo tanto usamos la fecha de validación
        getSignedStatusDate(signedStatusDate) {
            if (!signedStatusDate) {
                const validatedStatus = this.statuses.find(status => ['VALIDATED', 'VALIDADO'].includes(status.key));
                return validatedStatus ? validatedStatus.date : undefined;
            }
            return signedStatusDate;
        }
    },
    /**
     * @override
     */
    mounted() {
        this.fetchData();
        this.statuses = this.statusesOptions;
        for (let i = 0; i < this.statuses.length; i++) {
            const element = this.statuses[i];
            if (element.key === this.intervener.personal_data.intervener_status) {
                this.intervenerStatusStep = i;
            }
        }
    }
};
